import React from 'react';

export const Footer: React.FC = () => {
  return (
    <footer
      style={{
        borderTop: 'var(--border-chunky)',
        backgroundColor: 'var(--color-fg)',
        color: 'var(--color-bg)',
        marginTop: 'auto',
      }}
    >
      <div
        className="container"
        style={{ padding: 'var(--space-6) var(--space-4)' }}
      >
        <div className="flex justify-between items-center flex-wrap gap-4">
          <div style={{ display: 'flex', flexDirection: 'column', gap: '2px' }}>
            <span
              style={{
                fontFamily: 'var(--font-display)',
                fontSize: 'var(--text-sm)',
                textTransform: 'uppercase',
                letterSpacing: '0.1em',
              }}
            >
              WebGen Engine
            </span>
            <span
              style={{
                fontFamily: 'var(--font-body)',
                fontSize: 'var(--text-sm)',
                opacity: 0.7,
              }}
            >
              Generate policy-compliant static websites
            </span>
          </div>
          <div
            style={{
              fontFamily: 'var(--font-mono)',
              fontSize: 'var(--text-xs)',
              opacity: 0.7,
            }}
          >
            v1.0.0
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
